'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { DONATION_ROUTES } from '@/constants';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { BenefitCard } from '../BenefitCard';
interface StaticBannerProps {
  institutionId: number;
  className?: string;
}
export const BenefitsBanner = t0 => {
  const $ = _c(30);
  const {
    institutionId,
    className
  } = t0;
  const {
    entry
  } = useWebviewTypeEntry();
  const [activeIndex, setActiveIndex] = useState(1);
  let t1;
  if ($[0] !== entry || $[1] !== institutionId) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/home/institution-event"]({
      query: {
        institutionId,
        page: 1,
        size: 5,
        excludeEndedYN: true,
        entry
      }
    });
    $[0] = entry;
    $[1] = institutionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1,
      select: _temp
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: data_0
  } = useSuspenseQuery(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Autoplay({
      delay: 5000,
      stopOnInteraction: false
    });
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const autoplayPlugin = t3;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loop: true,
      align: "start"
    };
    t5 = [autoplayPlugin];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t4, t5);
  let t6;
  if ($[8] !== emblaApi) {
    t6 = () => {
      if (!emblaApi) {
        return;
      }
      setActiveIndex(emblaApi.selectedScrollSnap() + 1);
    };
    $[8] = emblaApi;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const onSelect = t6;
  let t7;
  let t8;
  if ($[10] !== emblaApi || $[11] !== onSelect) {
    t7 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t8 = [emblaApi, onSelect];
    $[10] = emblaApi;
    $[11] = onSelect;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  if (data_0 && data_0?.totalCount === 0) {
    return null;
  }
  let t9;
  if ($[14] !== className) {
    t9 = cn("relative overflow-hidden rounded-small", className);
    $[14] = className;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== activeIndex || $[17] !== data_0) {
    t10 = data_0 && data_0.contents.length > 1 && <div className="absolute right-12 top-12 z-10 whitespace-nowrap rounded-pill bg-Gray-black/20 px-8 py-2 font-600 text-Gray-white typo-caption2">{`${activeIndex} / ${data_0.contents.length}`}</div>;
    $[16] = activeIndex;
    $[17] = data_0;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== data_0?.contents) {
    t11 = data_0?.contents.map(_temp2);
    $[19] = data_0?.contents;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <div className="flex gap-8">{t11}</div>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== emblaRef || $[24] !== t12) {
    t13 = <div className="relative overflow-hidden" ref={emblaRef}>{t12}</div>;
    $[23] = emblaRef;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13 || $[28] !== t9) {
    t14 = <section className={t9}>{t10}{t13}</section>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
function _temp(data) {
  return data.context;
}
function _temp2(item) {
  return <div key={item.eventId} className="min-w-0 flex-[0_0_100%]"><BenefitCard title={item.title} bannerUrl={item.bannerImageUrl} pcBannerUrl={item.pcBannerImageUrl} href={DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
      eventId: item.eventId
    })} /></div>;
}